
if($(".video-container").length > 0 && $(".video-container iframe").length > 0){
    $(".video-container img").click(function(){
        $(this).hide();
        $(this).siblings("iframe")[0].src += "?autoplay=1";
        $(this).siblings("iframe").show();
        $(this).parent().addClass("playing");
    });
}
